import * as Api from '@ViewModels';
import salesforceLogo from '../../../../assets/logo_salesforce.svg';
import { baseStyleSheet } from '../../../../styles/styles';
import { SalesforceIntegrationGraphic } from '../../../svgs/graphics/SalesforceIntegrationGraphic';
import { IntegrationCard, useIntegrationCard } from '../IntegrationCard';
import { styleSheet } from './styles';

export const DashboardSalesforceIntegrationCard = () => {
	const { getLogoImgProps, getCloseButtonProps, getCtaButtonProps, getIntegrationTitleProps, showCard } =
		useIntegrationCard({
			closeIntegrationEventName: 'SalesforceIntegrationClosed',
			enableUrlPath: '/integrations/Salesforce',
			integrationEnableEventName: 'SalesforceIntegrationEnableClick',
			pendingAction: Api.PendingActions.ConnectSalesforce,
			checkApiPendingAction: true,
		});

	if (!showCard) {
		return null;
	}

	return (
		<IntegrationCard
			closeButtonProps={getCloseButtonProps()}
			IntegrationGraphic={SalesforceIntegrationGraphic}
			headerLabel='Salesforce Integration'
			logoBgColor='#F8F9FA'
			logoImgProps={getLogoImgProps({ alt: 'Salesforce Logo', src: salesforceLogo })}
			ctaButtonProps={getCtaButtonProps({
				children: 'Connect with Salesforce',
				styleDeclaration: [baseStyleSheet.ctaButtonReverse, styleSheet.ctaButton],
			})}
			integrationTitleProps={getIntegrationTitleProps({
				styleDeclaration: styleSheet.integrationTitle,
			})}
		>
			<p>
				We are excited to announce that you can integrate your Salesforce account with Levitate. With this integration,
				we will have the ability to pull client information, including names, email, phone number, and more &mdash;
				making staying in touch even easier.
			</p>
		</IntegrationCard>
	);
};
